import { AssetDetails } from 'src/services/responseTypes/singlePlayResponse';
import {
  setLocalStorage,
  getLocalStorage,
  deleteLocalStorage
} from 'src/utils/browserStorageHandler';

const STORAGE_KEY = 'gatingCustomProps';

export const setGatingCustomProps = (props: Record<string, unknown>) => {
  setLocalStorage(STORAGE_KEY, JSON.stringify(props));
};

export const getGatingCustomProps = () => {
  const stored = getLocalStorage(STORAGE_KEY);
  if (!stored) return {};
  try {
    return typeof stored === 'string' ? JSON.parse(stored) : stored;
  } catch (e) {
    return {};
  }
};

export const clearGatingCustomProps = () => {
  deleteLocalStorage(STORAGE_KEY);
};

export const getGatingContentProperties = (
  data: AssetDetails,
  source: string
) => {
  return {
    Source: source,
    'Content Name': data?.title || 'N/A',
    'Content Type': data?.asset_subtype || 'N/A'
  };
};
